import _ from 'lodash';

/**
 * Utilities Class
 */
class Utils {
  /**
   * Timers
   * @type {Object}
   */
  static timers = {};

  static currPlacementIdx = 100;

  /**
   * Regular Expressions
   * @type {Object}
   */
  static regexes = {
    queryString: /[?&]+([^=&]+)=([^&]*)/gi,
    queryStringRt: /[?&]+rt_?([^=&]+)=([^&]*)/gi,
    // eslint-disable-next-line max-len
    isMobile: /(?!.*PC.*)(?:iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile)/i,
    // eslint-disable-next-line max-len
    isTablet: /(?:ipad|a1_07|a1-810|a1-811|a1-830|a3000-h|a3300-hv|a3500-f|a3500-fl|a3500-h|a3-a10|a5500-f|a5500-h|a7600-f|a7600-h|android 3|archos 101|archos 80g9|aries_785|arnova 101|at100|at10-a|at200|at300|b1-710|b1-711|b1-730|b1-770|b1-780|b1-810|b1-830|b1-850|b1-a71|b6000-f|b6000-h|b8000-f|b8000-h|b8080-f|b8080-h|bn nookhd+|bnrv200|bntv250|bntv250a|bntv400|bntv450|bntv600|breeze 10|cm_tenderloin|dell streak 7|dl1010q|e2281|e-tab ivory|gt-n5100|gt-n5110|gt-n8000|gt-n8010|gt-n8013|gt-n8020|gt-p1000|gt-p1010|gt-p3100|gt-p3110|gt-p3113|gt-p5100|gt-p5110|gt-p5113|gt-p5200|gt-p5210|gt-p5220|gt-p7300|gt-p7310|gt-p7500|gt-p7510|hpwos|hudl 2|ideapad|ideatab|k00e|k00f|k010|k011|k012|k017|k01a|kfapwa |kfapwi|kfarwi|kfaswi|kfauwi|kfdowi|kffowi|kfgiwi|kfjwa|kfjwi|kfmewi|kfot|kfsawa|kfsawi|kfsowi|kfsuwi|kftbwi|kfthwa|kfthwi|kftt|kindle|lguk410|lguk750|lguk932|lg-v400|lg-v410|lg-v490|lg-v495|lg-v496|lg-v497|lg-v500|lg-v520|lg-v521|lg-v522|lg-v700|lg-v930|lifetab|m532|me172v|me173x|me301t|me302c|me302kl|me371mg|mediapad|memo pad|micromax_a101|mz601|mz604|nexus 10|nexus 7|nx008hd8g|nx16a10132s|nx16a11264|nx16a8116k|nx700qc|nx785qc8g|nxa116qc164|nxa8qc116|onda v989|p310a|p310x|p320x|padfone|playbook|pmp5580c|pmp7280c3g|pmt3377_wi|pmt7077_3g|qmv7a|qmv7b|qtair7|qtaqz3|qv830|rct6103w46|rct6203w46|rct6213w87dk|rct6213w87m|rct6303w87dk|rct6303w87m|rct6513w87|rct6573w23|rct6603w47m7|rct6603w87m7|rct6703w13|rct6773w22|rct6773w42b|rct6873w42m|rct6973w43|rct6k03w13|s5000-f|s5000-h|s6000l-f|s920_row|sch-i705|sch-i800|sch-i915|sch-i925|sgh-i467|sgh-i497|sgh-i777|sgp311|sgp312|sgp321|sgp511|sgp512|sgp521|sgp561|sgp611|sgp612|sgp621|sgp712|sgp771|sgpt12|sgpt13|shv-e210k|slider sl101|smart tab|sm-p550|sm-p600|sm-p605|sm-p900|sm-p905|sm-t\d\d\d|tab 2 a10-70f|tab 2 a7-30hc|tab 2 a8-50f|tab 2 a8-50lc|tab s8-50f|tab2a7-10f|tab2a7-20f|tablet|tb2-x30f|tb3-710f|tb3-710i|tb3-850f|tb3-850m|tb3-x70f|tb-8504f|tb-8704f|tb-x103f|tb-x304f|tc802a|tf300t|tf700t|touchpad|tf201|tf101|venue 7 3730|venue 7 hspa+|venue 8 3830|venue 8 7840|venue 8 hspa+|vk810 4g|vk815|vodafone smart ii|xolo a700|xoom|yb1-x90f|yoga b6000-f|yoga b8000-f|yt3-850f|yt3-x50f|yt3-x90f|yt-x703f|zaffire 1010)/i,
    domainURLS: {
      112842: /\/[0-9]{4,8}\//,
    },
  };

  /**
   * Resources Map
   * @type {Map<string, Promise>}
   */
  static resourcesMap = new Map(null);

  /**
   * Take Time for a Performance Measurements Point
   *
   * @param {String} name - point name
   * @param {number} [value] - point value
   */
  static takeTime(name, value) {
    value = value || performance.now();
    this.timers[name] = value;
  }

  /**
   * Get Time Difference from Timer
   *
   * @param {String} name
   * @return {number}
   */
  static getTime(name) {
    const timer = this.timers[name];
    return timer ? Math.round(performance.now() - timer) : 0;
  }

  /**
   * Clear Time
   *
   * @param {String} name
   */
  static clearTime(name) {
    delete this.timers[name];
  }

  /**
   * Get Duration from Page Start
   *
   * @return {number} - ms
   */
  static getPageSecond() {
    const now = _.result(window, 'performance.now', null);
    return now ? Math.round(now) : null;
  }

  static getQueryStringParam(name) {
    const params = Utils.getQueryStringParams();
    return _.isEmpty(params) ? null : params[name]
  }

  /**
   * Get Query String Parameters
   *
   * @param {String} url - an URL to extract the key value pairs from
   * @param {boolean} [rtOnly=false] - when true, returns only the key value pairs with the 'rt_' prefix
   *
   * @return {Object} - an object with key value pairs
   */
  static getQueryStringParams = _.memoize(
      function(url = window.location.href, rtOnly = false) {
        const params = {}; // params is a reference to the object
        if (typeof url !== 'string') {
          return params;
        }
        url.replace(
            rtOnly ? this.regexes.queryStringRt : this.regexes.queryString,
            (m, key, value) => {
              params[key] = value;
            },
        );
        return params;
      },
      function(url, rtOnly = false) {
        return `${rtOnly ? 1 : 0}_${url}`;
      },
  );

  /**
   * Takes a Query String Parameters
   *
   * @param {String} url - an URL to extract the key value pairs from
   * @param {boolean} [rtOnly=false] - when true, returns only the key value pairs with the 'rt_' prefix
   *
   * @return {Object} - an object with key value pairs
   */
  static paramsToQueryString = function(params) {
    return _.join(_.map(params, (val, key) => {
      return `${key}=${val}`;
    }), '&');
  };

  /**
   * Convert Milliseconds to Seconds
   *
   * @param {number} ms
   *
   * @return {number} - seconds representation with 2 digits after the decimal point
   */
  static ms2s(ms) {
    return Number(Number(ms / 1000).toFixed(2));
  }

  /**
   * Convert Seconds to Milliseconds
   *
   * @see Math.round()
   *
   * @param {number} seconds
   *
   * @return {number} - milliseconds representation rounded according to Math.round()
   */
  static s2ms(seconds) {
    return Math.round(seconds * 1000);
  }

  /**
   * Creates an Element from compiled lodash template
   *
   * @param {Function} compiledTemplate - compiled lodash template
   * @param {Object} [data]
   *
   * @return {Element | null} - the interpolated template,
   *                            otherwise null.
   */
  static createElementFromTemplate(compiledTemplate, data = {}) {
    const tempDiv = window.document.createElement('div');
    tempDiv.innerHTML = compiledTemplate(data);
    return tempDiv.firstElementChild;
  }

  /**
   * Load Script
   *
   * Create a script tag and append it to the `<head>`,
   * if there is no `<head>` insert the tag before the first script tag on page.
   *
   * @see https://html.spec.whatwg.org/multipage/syntax.html#syntax-tag-omission
   *
   * @param {String} scriptSource
   *
   * @return {Promise} - resolve when the script is loaded,
   *                     reject on error
   */
  static loadScript(scriptSource) {
    return new Promise((resolve, reject) => {
      // create script tag
      const script = window.document.createElement('script');
      script.src = scriptSource;
      script.onload = resolve;
      script.onerror = (error) => {
        reject(new Error(`failed to load script "${scriptSource}"`));
      };

      // insert script tag
      try {
        const head = window.document.getElementsByTagName('head')[0];
        if (head) {
          head.appendChild(script);
        } else {
          this.insertBefore(script, window.document.getElementsByTagName('script')[0]);
        }
      } catch (error) {
        reject(new Error(`failed to insert script "${scriptSource}"`));
      }
    });
  }

  /**
   * Load Style
   *
   * Create a link tag and append it to the `<head>`,
   * if there is no `<head>` create a `<style>` tag and insert the content inside
   *
   * @see https://html.spec.whatwg.org/multipage/syntax.html#syntax-tag-omission
   *
   * @param {String} styleSource
   *
   * @return {Promise} - resolves after the style is loaded
   */
  static loadStyle(styleSource) {
    const head = window.document.getElementsByTagName('head')[0];
    if (head) {
      // <head> exists
      return new Promise((resolve, reject) => {
        // create link tag
        const link = window.document.createElement('link');
        link.type = 'text/css';
        link.rel = 'styleSheet';
        link.href = styleSource;
        link.onload = resolve;
        link.onerror = () => {
          reject(new Error(`failed to load link "${styleSource}"`));
        };
        // insert link tag
        try {
          head.appendChild(link);
        } catch (error) {
          reject(new Error(`failed to insert link "${styleSource}"`));
        }
      });
    } else {
      // <head> does not exist
      // @internal fetch returns a Promise
      return fetch(styleSource).
          then((response) => response.text()).
          then((text) => {
            try {
              // create style tag
              const s = window.document.createElement('style');
              s.textContent = text;
              // insert style tag
              this.insertBefore(s, window.document.getElementsByTagName('script')[0]);
            } catch (error) {
              return Promise.reject(new Error(`failed to insert style "${styleSource}"`));
            }
          }).
          catch((fetchError) => {
            return Promise.reject(new Error(`failed to load style "${styleSource}"`));
          });
    }
  }

  /**
   * Insert a Node before another Node
   *
   * @param {Node} nodeToInsert
   * @param {Node} node
   *
   * @throws {Error}
   */
  static insertBefore(nodeToInsert, node) {
    if (nodeToInsert.parentNode) {
      node.parentNode.insertBefore(nodeToInsert, node);
    }
  }

  /**
   * Create Template Function from String using eval()
   *
   * @see eval()
   *
   * @param {String} functionString
   *
   * @return {Function}
   */
  static createTemplateFunctionFromString(functionString) {
    // generate a unique function name
    const functionName = _.uniqueId('RtTemplateFn_');
    // run the function with eval()
    eval(`window['${functionName}'] = ${functionString}`);
    // return the reference to the function
    return window[functionName];
  }

  /**
   * Get page height (in pixels)
   *
   * @param {Window} windowElement
   *
   * @return {number}
   */
  static getPageHeight(windowElement = window) {
    if (!windowElement) {
      return 0;
    }
    const documentBody = windowElement.document.body;
    const documentElement = windowElement.document.documentElement;
    return Math.max(
        documentBody.scrollHeight, documentElement.scrollHeight,
        documentBody.offsetHeight, documentElement.offsetHeight,
        documentBody.clientHeight, documentElement.clientHeight,
    );
  }

  /**
   * Get URL Cut (memoized)
   *
   * @param {number} scriptDomainId
   *
   * @return {string}
   */
  static getURLCut = _.memoize(function(scriptDomainId = x0) {
    if (_.has(Utils.regexes.domainURLS, scriptDomainId.toString())) {
      const firstMatch = window.location.href.search(Utils.regexes.domainURLS[scriptDomainId]);
      if (firstMatch !== -1) {
        return window.location.href.substring(0, firstMatch);
      }
    }
    return window.location.href;
  });

  /**
   * Is Element Displayed
   *
   * @param {Element} element
   *
   * @return {boolean}
   */
  static isElementDisplayed(element) {
    return !!(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  }

  /**
   * Is Safari
   *
   * @return {boolean}
   */
  static isSafari = _.memoize(function() {
    return navigator.vendor.includes('Apple');
  });

  /**
   * Top Offset
   *
   * Calculates element's absolute offset from the top of the page.

   * @param {Element} element
   *
   * @return {number} - pixels from the top
   */
  static topOffset(element) {
    let top = 0;
    do {
      let transformTopOffset = 0;
      if (window.getComputedStyle && window.WebKitCSSMatrix) {
        const transformValue = getComputedStyle(element).transform || getComputedStyle(element).webkitTransform;
        const transformMatrix = new window.WebKitCSSMatrix(transformValue);
        transformTopOffset = transformMatrix.m42;
      }
      top += element.offsetTop + transformTopOffset || 0;
      element = element.offsetParent;
    } while (element);

    return top;
  }


    /**
     * appends all the query params from the current url to any given a.href link on the page.
     * if link already has an existing identical query param, then it takes precedence.
     *
     * e.g. if current url is:
     *  https://www.readtheory.org/about?a=1&b=2&c=3
     *  and there is a link on the page with href='https://www.readtheory.org/privacy?c=5&d=6 or href='/privacy?c=5&d=6'
     *  then running this function will change the a link to href='/privacy?a=1&b=2&c=5&d=6'
     */
  static addQueryParamsToLinks() {
    const linkEls = document.querySelectorAll('a');
    const currParams = this.getQueryStringParams(window.location.href);
    _.forEach(linkEls, currLinkEl => {
      if (currLinkEl.href.startsWith('/') ||
          currLinkEl.href.startsWith('https://englishforeveryone.org')) {
          const linkParams = Utils.getQueryStringParams(currLinkEl.href);
          _.assign(currParams, linkParams);
          let baseUri = _.split(currLinkEl.href, '?')[0];
          currLinkEl.href =  baseUri+'?'+this.paramsToQueryString(currParams);
      }
    });
  }


  static loadScript(src, async = true) {
    return new Promise((resolve, reject) => {
      let js = document.createElement('script');
      js.src = src;
      js.onreadystatechange = function() {
        if (this.readyState == 'complete') {
          resolve();
        }
      }
      js.onload = function() {
        resolve();
      };
      js.onerror = function() {
        log.error('could not script from: '+src);
        reject();
      };
      if (async) {
        js.setAttribute('async', true);
      }
      document.head.appendChild(js);
    })
  }

  static injectStyle(styleStr) {
    const styleEl = document.createElement('style');
    styleEl.innerHTML = styleStr;
    document.head.appendChild(styleEl);
  }

  static removeQueryStringParam(key) {
    const params = this.getQueryStringParams()
    delete params[key];
    history.replaceState(null,null, _.head(window.location.href.split('?'))+'?'+this.paramsToQueryString(params));
  }

  static extractParamsFromUrl(url) {
    let str = url.split('?')[1];
    if (str) {
      str = str.split('#')[0];
    }
    if (typeof str === 'undefined') str='';
    let paramsMap = {};
    let str_dec = decodeURIComponent(str);
    str_dec.replace(
      new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
      function ($0, $1, $2, $3) {
        $3 = $3 || null;
        paramsMap[$1] = $3;
      });
    return paramsMap;
  }

  static getUrlParams() {
    return Utils.extractParamsFromUrl(window.location.href);
  }

  static getUTM() {
    const urlParams = Utils.getUrlParams();
    return {
      source: urlParams['utm_source'],
      medium: urlParams['utm_medium'],
      campaign: urlParams['utm_campaign'],
    };
  }

  static isMobile() {
    const isMobile = /iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(navigator.userAgent.toLowerCase()) && navigator.userAgent.search('PC') === -1;
    return isMobile;
  };

  static isMobileByWidth() {
    return Utils.getWindowWidth() < 900;
  }

  static isTablet() {
    const isTablet = /ipad|nexus 7|nexus 9|android 3.0|kindle|silk|kftt|kfot|kfjwa|kfjwi|kfsowi|kfthwa|kfthwi|kfapwa|kfapwi/i.test(navigator.userAgent.toLowerCase());
    return isTablet && navigator.userAgent.search('PC') === -1;
  };

  static isDesktop() {
    return !Utils.isMobile() && !Utils.isTablet();
  };

  static createPlacementEl(placementName, extraStyle = {}, extraData = {}) {
    const el = document.createElement('div');
    el.classList.add('pomad-placement');
    el.dataset.pmdPlacementIdx = Utils.currPlacementIdx;
    el.dataset.pmdPlacementName = placementName;
    Object.assign(el.dataset, extraData);
    Object.assign(el.style, extraStyle);
    el.style.textAlign = 'center';
    el.id = 'pmd-placement-' + placementName + '-' + Utils.currPlacementIdx;
    Utils.currPlacementIdx++;
    return el;
  }

  static isIntersectionObserverSupported() {
    return ('IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window);
  }

  static getWindowWidth() {
    return window.top.screen.width || window.top.innerWidth && window.top.document.documentElement.clientWidth ? Math.min(window.top.innerWidth, window.top.document.documentElement.clientWidth) : window.top.innerWidth || window.top.document.documentElement.clientWidth || window.top.document.getElementsByTagName('body')[0].clientWidth;
  }

  static setCookie(name, value, exdays = 1) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = `${name}=${value}; Path=/; Expires=${expires}`;
  }

  static deleteCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  static clearCookies() {
    Utils.deleteCookie('rt_abt')
    //Utils.deleteCookie('JSESSIONID') you can't delete HTTP Only Cookies
  }

}

window.clearCookies = Utils.clearCookies
export default Utils;
